export default __webpack_public_path__ + "static/media/john_wick_1.64dcc885.jpg";